export const LightMode = {
    '--color-primary': '#0066CC',
    '--color-secondary': '#004AAD',
    '--color-primary-background': '#0066CC',
    '--color-accent': '#0099FF',
    '--color-success': '#40CE7E',
    '--color-warning': '#FF7F3F',
    '--color-error': '#EF4444',
    '--color-info': '#3B82F6',
    '--color-background': '#F5F9FF',
    '--color-card-background': '#FFFFFF',
    '--color-input-background': '#F8FAFC',
    '--color-icon-primary': '#0066CC',
    '--color-icon-secondary': '#64748B',
    '--color-icon-background': '#E6F0FF',
    '--color-border': '#D9E6F6',
    '--color-text-primary': '#002267',
    '--color-text-secondary': '#333333',
    '--color-text-light': '#6B7381',
    '--color-text-white': '#FFFFFF',
    '--color-placeholder': '#8B959A',
    '--font-sans': "'Poppins', sans-serif",
  };
  
  export const DarkMode = {
    '--color-primary': '#2C5FBB',
    '--color-secondary': '#102A5D',
    '--color-primary-background': '#0A0A0A',
    '--color-accent': '#3F89E6',
    '--color-success': '#38B673',
    '--color-warning': '#E68F2D',
    '--color-background': '#050505',
    '--color-card-background': '#0C0C0C',
    '--color-input-background': '#252533',
    '--color-icon-primary': '#3F89E6',
    '--color-icon-background': '#0E0E0E',
    '--color-border': '#1A1A1A',
    '--color-text-primary': '#D4D4D4',
    '--color-text-secondary': '#A8A8A8',
    '--color-text-light': '#8C8C8C',
    '--color-text-white': '#D4D4D4',
    '--color-placeholder': '#707070',
    '--font-sans': "'Poppins', sans-serif",
  };
  